import React, { useState } from 'react';
import { insertarMetas } from '../api/apiConfig';
import { MdUpload, MdSave, MdInfo } from 'react-icons/md';

const IngresarMetas = () => {
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const fixEncoding = (text) => {
    return text
      .replace(/Ã±/g, 'ñ')
      .replace(/Ã¡/g, 'á')
      .replace(/Ã©/g, 'é')
      .replace(/Ã­/g, 'í')
      .replace(/Ã³/g, 'ó')
      .replace(/Ãº/g, 'ú')
      .replace(/Ã/g, 'Á')
      .replace(/Ã‰/g, 'É')
      .replace(/Ã/g, 'Í')
      .replace(/Ã"/g, 'Ó')
      .replace(/Ãš/g, 'Ú')
      .replace(/Ã'/g, 'Ñ');
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      let text = e.target.result;
      text = fixEncoding(text);
      const lines = text.split('\n').filter(line => line.trim());
      
      if (lines.length < 2) {
        setMessage('El archivo debe contener al menos una fila de datos además del encabezado');
        setMessageType('error');
        return;
      }

      const headers = lines[0].split(';').map(h => h.trim());
      const expectedHeaders = ['EJECUTIVO', 'EQUIPO_VENTAS', 'PLATAFORMA', 'META_MET_MAR', 'META_MET_VOL', 'META_MET_CLI_OPE', 'BASE_CLI_OPE', 'BASE_N_OPE', 'METAS_CREDITO', 'METAS_LEASING', 'ANIO_MET', 'MES_MET'];
      
      const missingHeaders = expectedHeaders.filter(h => !headers.includes(h));
      if (missingHeaders.length > 0) {
        setMessage(`Faltan las siguientes columnas: ${missingHeaders.join(', ')}`);
        setMessageType('error');
        return;
      }

      const data = lines.slice(1).map((line, index) => {
        const values = line.split(';').map(v => v.trim());
        const row = {};
        
        headers.forEach((header, i) => {
          if (expectedHeaders.includes(header)) {
            let value = values[i] || '';
            // Convertir comas a puntos para campos numéricos
            if (['META_MET_MAR', 'META_MET_VOL', 'META_MET_CLI_OPE', 'BASE_CLI_OPE', 'BASE_N_OPE', 'METAS_CREDITO', 'METAS_LEASING'].includes(header)) {
              value = value.replace(',', '.');
            }
            row[header] = value;
          }
        });
        
        return row;
      }).filter(row => row.EJECUTIVO && row.EJECUTIVO.trim() !== '');

      setCsvData(data);
      setMessage(`Archivo cargado exitosamente. ${data.length} registros encontrados.`);
      setMessageType('success');
    };

    reader.readAsText(file, 'ISO-8859-1');
  };

  const handleInsertData = async () => {
    if (csvData.length === 0) {
      setMessage('No hay datos para insertar');
      setMessageType('error');
      return;
    }

    setLoading(true);
    try {
      await insertarMetas(csvData);
      setMessage('Metas insertadas exitosamente');
      setMessageType('success');
      setCsvData([]);
    } catch (error) {
      setMessage(`Error al insertar metas: ${error.message}`);
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-baseline gap-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Ingresar Metas</h1>
      </div>

      <div className="seccion-datos">
        <h3 style={{color: 'var(--if-primary)', margin: '0 0 1rem 0', fontSize: '1.2rem', fontWeight: '600'}}>
          Cargar Archivo CSV
        </h3>
        
        <div className="mb-4 p-4" style={{backgroundColor: '#f0f9ff', border: '1px solid #0ea5e9', borderRadius: '8px'}}>
          <div className="flex items-start gap-3">
            <MdInfo className="text-blue-600 mt-1" size={20} />
            <div>
              <h4 className="font-semibold text-blue-800 mb-2">Formato del archivo CSV:</h4>
              <p className="text-sm text-blue-700 mb-2">
                El archivo debe contener las siguientes columnas separadas por punto y coma (;):
              </p>
              <div className="text-xs text-blue-600 font-mono bg-blue-50 p-2 rounded">
                EJECUTIVO;EQUIPO_VENTAS;PLATAFORMA;META_MET_MAR;META_MET_VOL;META_MET_CLI_OPE;BASE_CLI_OPE;BASE_N_OPE;METAS_CREDITO;METAS_LEASING;ANIO_MET;MES_MET
              </div>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            Seleccionar archivo CSV:
          </label>
          <input
            type="file"
            accept=".csv"
            onChange={handleFileUpload}
            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
        </div>

        {message && (
          <div className={`mb-4 p-3 rounded ${messageType === 'success' ? 'bg-green-100 text-green-700 border border-green-300' : 'bg-red-100 text-red-700 border border-red-300'}`}>
            {message}
          </div>
        )}

        {csvData.length > 0 && (
          <>
            <div className="flex justify-between items-center mb-4">
              <h4 style={{color: 'var(--if-primary)', fontSize: '1.1rem', fontWeight: '600'}}>
                Vista previa de datos ({csvData.length} registros)
              </h4>
              <button
                onClick={handleInsertData}
                disabled={loading}
                className="btn-primary flex items-center gap-2"
                style={{
                  background: loading ? '#9ca3af' : 'linear-gradient(135deg, var(--if-success) 0%, #16a34a 100%)',
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                <MdSave size={16} />
                {loading ? 'Insertando...' : 'Insertar Metas'}
              </button>
            </div>

            <div className="tabla-container" style={{overflowX: 'auto', maxHeight: '400px', overflowY: 'auto'}}>
              <table className="w-full" style={{fontSize: '0.875rem', minWidth: '1200px'}}>
                <thead style={{position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1}}>
                  <tr>
                    <th style={{backgroundColor: 'var(--if-primary)', color: 'white', minWidth: '120px'}}>Ejecutivo</th>
                    <th style={{backgroundColor: 'var(--if-primary)', color: 'white', minWidth: '120px'}}>Equipo Ventas</th>
                    <th style={{backgroundColor: 'var(--if-primary)', color: 'white', minWidth: '100px'}}>Plataforma</th>
                    <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '100px'}}>Meta Margen</th>
                    <th style={{backgroundColor: '#dbeafe', color: 'white', minWidth: '100px'}}>Meta Volumen</th>
                    <th style={{backgroundColor: '#dcfce7', color: 'white', minWidth: '120px'}}>Meta Clientes Op.</th>
                    <th style={{backgroundColor: '#f3e8ff', color: 'white', minWidth: '100px'}}>Base Clientes</th>
                    <th style={{backgroundColor: '#f3e8ff', color: 'white', minWidth: '100px'}}>Base N° Op.</th>
                    <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '100px'}}>Metas Crédito</th>
                    <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '100px'}}>Metas Leasing</th>
                    <th style={{backgroundColor: 'var(--if-primary)', color: 'white', minWidth: '80px'}}>Año</th>
                    <th style={{backgroundColor: 'var(--if-primary)', color: 'white', minWidth: '80px'}}>Mes</th>
                  </tr>
                </thead>
                <tbody>
                  {csvData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.EJECUTIVO}</td>
                      <td>{row.EQUIPO_VENTAS}</td>
                      <td>{row.PLATAFORMA}</td>
                      <td style={{textAlign: 'right'}}>{row.META_MET_MAR}</td>
                      <td style={{textAlign: 'right'}}>{row.META_MET_VOL}</td>
                      <td style={{textAlign: 'right'}}>{row.META_MET_CLI_OPE}</td>
                      <td style={{textAlign: 'right'}}>{row.BASE_CLI_OPE}</td>
                      <td style={{textAlign: 'right'}}>{row.BASE_N_OPE}</td>
                      <td style={{textAlign: 'right'}}>{row.METAS_CREDITO}</td>
                      <td style={{textAlign: 'right'}}>{row.METAS_LEASING}</td>
                      <td style={{textAlign: 'center'}}>{row.ANIO_MET}</td>
                      <td style={{textAlign: 'center'}}>{row.MES_MET}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default IngresarMetas;